function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import get from 'lodash/get';
import times from 'lodash/times';
import zipObject from 'lodash/zipObject';
import styles from './CodeFormPartial.pcss';
const CodeFormPartial = ({ id, codeLength, className, isDisabled = false, isOneLiner = false, onSetFormValue })=>{
    useStyles(styles);
    const codeFields = useRef(times(codeLength, (i)=>`code_${i}`));
    const initValues = useRef(zipObject(codeFields.current, codeFields.current.map(()=>'')));
    const inputs = useRef([]);
    const isDisabledRef = useRef(isDisabled);
    const [values, setValues] = useState(initValues.current);
    useEffect(()=>{
        if (isDisabled && isDisabled !== isDisabledRef.current) {
            setValues(initValues.current);
        }
        isDisabledRef.current = isDisabled;
    }, [
        isDisabled
    ]);
    const setValue = (fieldId, value)=>{
        setValues(_object_spread_props(_object_spread({}, values), {
            [fieldId]: value
        }));
        const mergedValue = codeFields.current.map((cid)=>cid === fieldId ? value : values[cid]).join('');
        onSetFormValue({
            id,
            value: mergedValue
        });
    };
    const focusWithPreventScroll = (inputElement)=>{
        if (inputElement) {
            try {
                inputElement.focus({
                    preventScroll: true
                });
            } catch (e) {
                inputElement.focus();
            }
        }
    };
    const onFocusHandler = (e)=>{
        focusWithPreventScroll(e.target);
    };
    const onTouchHandler = (e)=>{
        e.preventDefault();
    };
    const goToNextInput = (i)=>{
        const nextInput = get(inputs.current, i + 1);
        focusWithPreventScroll(nextInput);
    };
    const goToPrevInput = (i)=>{
        const nextInput = get(inputs.current, i - 1);
        focusWithPreventScroll(nextInput);
    };
    const handleKeyDown = (evt, i, fieldId)=>{
        switch(evt.key){
            case 'ArrowLeft':
                {
                    goToPrevInput(i);
                    break;
                }
            case 'ArrowRight':
                {
                    goToNextInput(i);
                    break;
                }
            case 'Backspace':
            case 'Delete':
            case ' ':
                {
                    setValue(fieldId, '');
                    break;
                }
            default:
                {
                    break;
                }
        }
    };
    const handleInput = (evt, i, fieldId)=>{
        const rawValue = evt.target.value.toUpperCase();
        const value = rawValue.slice(-1);
        if (!value.match(/^[A-Z0-9]$/)) {
            setValue(fieldId, '');
            return;
        }
        setValue(fieldId, value);
        goToNextInput(i);
    };
    const setInputRef = (el, i)=>{
        if (inputs.current[i] || isDisabled) {
            return;
        }
        if (!i && el) {
            focusWithPreventScroll(el);
        }
        inputs.current[i] = el;
    };
    const onPaste = (evt)=>{
        const clipboardData = evt.clipboardData.getData('text/plain');
        let mergedValue = '';
        const newValues = zipObject(codeFields.current, codeFields.current.map((cf, idx)=>{
            const value = clipboardData[idx].toUpperCase();
            if (!value.match(/^[A-Z0-9]$/)) {
                return '';
            }
            mergedValue += value;
            return value;
        }));
        setValues(newValues);
        onSetFormValue({
            id,
            value: mergedValue
        });
    };
    const renderField = (i)=>{
        const fieldId = `code_${i}`;
        const onKeyDown = (evt)=>handleKeyDown(evt, i, fieldId);
        const onChange = (evt)=>handleInput(evt, i, fieldId);
        const onSetInputRef = (el)=>setInputRef(el, i);
        return /*#__PURE__*/ _jsx("input", {
            id: fieldId,
            value: values[fieldId],
            className: `form-control ${styles.number__digit}`,
            disabled: isDisabled,
            autoComplete: "off",
            maxLength: 1,
            onChange: onChange,
            onKeyDown: onKeyDown,
            onPaste: onPaste,
            ref: onSetInputRef,
            onFocus: onFocusHandler,
            onTouchMove: onTouchHandler
        }, fieldId);
    };
    return /*#__PURE__*/ _jsx("div", {
        className: cn('form-group', {
            'form-group--one-liner': isOneLiner
        }, className),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.number,
            children: times(codeLength, (i)=>renderField(i))
        })
    });
};
export default CodeFormPartial;
